import { motion } from "framer-motion";
import { Quotes, Star } from "@phosphor-icons/react";

const testimonials = [
  {
    quote:
      "They saved us from foreclosure and handled everything professionally. We had a fair cash offer in a day and closed in under two weeks. Highly recommend!",
    name: "Maria & James T.",
    detail: "Sold to avoid foreclosure",
  },
  {
    quote:
      "I inherited a property out of state and didn't want to deal with repairs or agents. They bought it as-is in 10 days and made the whole thing painless.",
    name: "David R.",
    detail: "Inherited property sale",
  },
];

export const Testimonials = () => (
  <section
    data-testid="testimonials-section"
    className="bg-white py-20 md:py-32 px-6 md:px-12 lg:px-16"
  >
    <div className="max-w-7xl mx-auto">
      <div className="text-center max-w-2xl mx-auto">
        <span className="uppercase text-xs md:text-sm tracking-[0.2em] font-semibold text-emerald-700">
          Real Stories
        </span>
        <h2 className="font-heading mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
          Hear From Homeowners We've Helped
        </h2>
      </div>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-8">
        {testimonials.map((t, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
            data-testid={`testimonial-${i + 1}`}
            className="bg-stone-50 p-8 rounded-2xl border border-stone-100 relative"
          >
            <Quotes weight="fill" className="h-10 w-10 text-emerald-200" />
            <div className="flex gap-1 mt-4">
              {[...Array(5)].map((_, s) => (
                <Star key={s} weight="fill" className="h-5 w-5 text-amber-500" />
              ))}
            </div>
            <p className="mt-4 text-lg text-slate-700 leading-relaxed">"{t.quote}"</p>
            <div className="mt-6">
              <p className="font-heading font-semibold text-slate-900">{t.name}</p>
              <p className="text-sm text-slate-500">{t.detail}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
